(() => {
 'use strict';
 if(window.MsofasWishlistAnalytics)return;
 const cfg=window.MsofasWishlistAnalyticsConfig||{};
 if(!cfg.enabled)return;
 const visitorKey='msofas:analytics:visitor:v1',journeyKey='msofas:analytics:journey:v1';
 const revokeKey='msofas:analytics:pending-revocations:v1';
 const uuid=s=>typeof s==='string'&&/^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i.test(s);
 const permitted=()=>{
  try{
   const cp=window.Shopify?.customerPrivacy;
   return cp?.analyticsProcessingAllowed?.()===true&&cp?.currentVisitorConsent?.().analytics==='yes';
  }catch{return false;}
 };
 const endpoint=cfg.endpoint||'/apps/msofas-analytics';
 if(!endpoint.startsWith('/')||endpoint.startsWith('//'))return;
 let memoryId,epoch=0,flushing=false;
 const pending=new Set();
 try{for(const id of JSON.parse(localStorage.getItem(revokeKey)||'[]'))if(uuid(id))pending.add(id);}catch{}
 function persistPending(){
  try{if(pending.size)localStorage.setItem(revokeKey,JSON.stringify([...pending]));
   else localStorage.removeItem(revokeKey);}catch{}
 }
 async function post(path,data,{privacy=false}={}) {
  if(!privacy&&!permitted())return null;
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),1500);
  try{
   const response=await fetch(endpoint+path,{method:'POST',credentials:'same-origin',keepalive:true,
    headers:{'Content-Type':'application/json'},body:JSON.stringify(data),signal:controller.signal});
   if(!response.ok)return null;
   return await response.json();
  }catch{return null;}finally{clearTimeout(timer);}
 }
 async function flushRevocations(){
  if(flushing)return;
  flushing=true;
  try{
   for(const id of pending){
    if((await post('/revoke',{visitor:id},{privacy:true}))?.ok)pending.delete(id);
    else break;
   }
  }finally{flushing=false;persistPending();}
 }
 function withdraw(){
  epoch++;
  let id=memoryId;
  try{id=localStorage.getItem(visitorKey)||id;localStorage.removeItem(visitorKey);sessionStorage.removeItem(journeyKey);}catch{}
  memoryId=null;
  if(uuid(id))pending.add(id);
  persistPending();
  void flushRevocations();
 }
 function visitor(){
  if(!permitted())return null;
  try{
   let id=localStorage.getItem(visitorKey);
   if(!uuid(id)||pending.has(id)){id=crypto.randomUUID();localStorage.setItem(visitorKey,id);}
   return memoryId=id;
  }catch{return memoryId ||= crypto.randomUUID();}
 }
 function track(type,item) {
  const id=visitor();if(!id||!item?.handle)return Promise.resolve(null);
  return post('/event',{id:crypto.randomUUID(),visitor:id,type,handle:item.handle,
   variantId:item.variantId?String(item.variantId):null,title:item.title||item.handle});
 }
 function visit(item){
  if(!permitted()||!item?.handle)return;
  try{sessionStorage.setItem(journeyKey,JSON.stringify({handle:item.handle,title:item.title||item.handle,at:Date.now()}));}catch{}
  void track('view',item);
 }
 function journey(handle){
  if(!permitted())return null;
  try{
   const j=JSON.parse(sessionStorage.getItem(journeyKey));
   return j?.handle===handle&&Number.isFinite(j.at)&&Date.now()>=j.at&&Date.now()-j.at<30*60000?j:null;
  }catch{return null;}
 }
 async function cartProperties(item,variantId,{fromWishlist=false}={}) {
  if(!permitted()||!item?.handle||!/^[1-9]\d{0,24}$/.test(String(variantId)))return {};
  if(!fromWishlist&&!journey(item.handle))return {};
  const generation=epoch,id=visitor();
  // A view is a wishlist interaction, not a save or a successful cart addition.
  const seen=await track('view',item);
  if(!seen||!permitted()||epoch!==generation)return {};
  const result=await post('/intent',{visitor:id,handle:item.handle,variantId:String(variantId)});
  return permitted()&&epoch===generation&&uuid(result?.reference)?{_msw_ref:result.reference}:{};
 }
 function consentChanged(){
  if(!permitted())withdraw();
 }
 document.addEventListener('visitorConsentCollected',consentChanged);
 window.addEventListener('online',()=>void flushRevocations());
 window.addEventListener('storage',e=>{
  if(e.key===visitorKey&&e.oldValue!==e.newValue){
   epoch++;memoryId=null;
   try{sessionStorage.removeItem(journeyKey);}catch{}
  }
 });
 // Load Shopify's public privacy API; never infer consent from theme cookies.
 if(!window.Shopify?.customerPrivacy&&window.Shopify?.loadFeatures){
  window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{
   if(!error)consentChanged();
  });
 }else if(window.Shopify?.customerPrivacy)consentChanged();
 void flushRevocations();
 window.MsofasWishlistAnalytics={track,visit,cartProperties,permitted,journey};
})();
